export const hasBadRepresentantScore = (user) => {
  const inpiData = user.inpiData
  return inpiData && inpiData.representant_score < 0.8
}

export const representantChangeInProgress = (user) => !!user.representant.repres_change_netheos_status

export const hasBadDenominationScore = (user) => {
  const inpiData = user.inpiData
  return inpiData && inpiData.social_denomination_score < 0.7
}

export const inpiCheckFailed = (user) => {
  return hasBadRepresentantScore(user)
  || hasBadDenominationScore(user)
  || user.forme_juridique_pappers_matches === false
  || user.hasForbiddenJuridicForm
  || representantChangeInProgress(user)
}

export const listBlocageExplanations = (user) => {
  const explanations = []
  if (hasBadRepresentantScore(user)) {
    explanations.push([
      `Le représentant légal que vous avez déclaré (${user.representant.firstname} ${user.representant.name}) n\'apparaît pas sur le site de l’INPI.`,
      '- Si le représentant légal est en cours de modification, merci d’adresser à contact@ma-domiciliation.fr un PV d’AG signé par le représentant légal actuel et le nouveau représentant légal, pour confirmer que le changement est en cours.',
      '- Pour toute autre situation, merci d’adresser un email à contact@ma-domiciliation.fr.'
    ])
  }

  if (hasBadDenominationScore(user)) {
    explanations.push([
      'Le nom de la société que vous avez déclaré est différent du nom présent sur l’INPI.',
      '- Si le nom de société a déjà été changé, merci de nous adresser par email votre nouveau Kbis à contact@ma-domiciliation.fr.',
      '- Si le nom de société est en cours de changement, merci d’adresser à contact@ma-domiciliation.fr un PV d’AG signé par le représentant légal pour confirmer que le changement est en cours.',
      '- Pour toute autre situation, merci d’adresser un email à contact@ma-domiciliation.fr.'
    ])
  }

  if (user.forme_juridique_pappers_matches === false) {
    explanations.push(['La forme juridique déclarée sur notre site est différente de celle de l’INPI. Merci d’adresser un email à contact@ma-domiciliation.fr'])
  }

  if (user.hasForbiddenJuridicForm) {
    explanations.push(['La forme juridique détectée sur l\'INPI ne peut légalement pas être acceptée en domiciliation commerciale. Merci d’adresser un email à contact@ma-domiciliation.fr'])
  }
  return explanations
}
